module.exports = __webpack_public_path__ + "img/assure_demo_v3.5db011be.png";